import { watch } from "vue";
/**
 * Emits an event whenever a value changes
 * @param ref value to watch
 * @param emit event emitter function
 * @param name event to emit
 */
export function useEmit(ref, emit, name) {
    watch(() => ref.value, () => {
        emit(name, ref.value);
    });
}
